export default class RetryRenewal {
    constructor() {
        this.handleRetryRenewal();
    }

    handleRetryRenewal() {
        const button = document.querySelector("#vindi-retry-renewal-button");
        const hidden = document.querySelector("#vindi-retry-renewal-order");
        const nonce = document.querySelector("#vindi_retry_renewal_nonce");

        if (button && hidden && nonce) {
            button.addEventListener('click', (e) => {

                const body = new FormData();
                body.append('action', 'vindi_retry_renewal');
                body.append('order', hidden.value);
                body.append('nonce', nonce.value);

                this.setLoader();
                button.setAttribute('disabled', true);

                fetch(ajaxurl, {
                    method: "POST",
                    body: body,
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.status) {
                            if (data.status == "success") {
                                window.location.reload();
                            }
                        }
                    });
            });
        }
    }

    setLoader(active = true) {
        const loader = document.querySelector('#vindi-retry-renewal-form .loader');

        if (loader) {
            if (active) {
                loader.classList.add('active');
            } else {
                loader.classList.remove('active');
            }
        }
    }
}
